export enum CellType {
  Unknown = 0,
  Dropdown = 1,
  ZeroOrPositiveRational = 2,
  NullOrZeroOrPositiveRational = 3,
}
